module.exports = __webpack_public_path__ + "img/logo-288-x-294-mixed.1f2fba6d.svg";